import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { PagingService } from 'src/app/service/paging.service';
import { ChosenRegion, ChosenSchoolDistrict, StudentEligibilityCounts } from './model/student-eligibility-count';
import { UnduplicatedStudentEligibilities } from './model/unduplicated-student-eligibilities';
import { StudentEligibilitiesService } from '../../children/service/student-eligibilities.service';
import { MatSort, Sort } from '@angular/material/sort';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { FormGroup } from '@angular/forms';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { ApiFetchExportDataService } from 'src/app/service/api-fetchexportdata.service';
import { Router } from '@angular/router';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ChildReportsService } from '../service/child-reports.service';
import { RegionDataService } from 'src/app/component/common-components/service/region-data.service';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { CountsChildrenModalComponent } from './counts-children-modal/counts-children-modal.component';
import { HtmlToStringPipe } from 'src/app/pipes/html-to-string.pipe';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { NumberCommaPipe } from 'src/app/pipes/number-comma.pipe';

@Component({
    selector: 'app-counts',
    templateUrl: './counts.component.html',
    styleUrls: ['./counts.component.scss']
})
export class CountsComponent implements OnInit {
    //@ViewChild(MatPaginator) regionPaginator!: MatPaginator;
    //@ViewChild(MatPaginator) districtPaginator!: MatPaginator;
    @ViewChild(MatSort) regionSort: MatSort;
    @ViewChild(MatSort) districtSort: MatSort;
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appSelectedSchoolDistricts') appSelectedSchoolDistricts!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    searchCountsForm: FormGroup;
    selectedPerformancePeriod?: string = '';
    performancePeriod: string = '';

    allRegions: Region[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    displayedColumns: string[] = ['CODE', 'EIP', 'EC1', 'EC2', 'EST'];
    districtColumns: string[] = ['DISTRICTS', 'EIP', 'EC1', 'EC2', 'EST'];
    alternateFooter: string[] = ['F-Total', 'F-EIP', 'F-EC1', 'F-EC2', 'F-EST'];
    resetField: boolean = false;
    isExporting: boolean = false;
    hasExports: boolean = false;
    bAllowRegionalExport: boolean = false;
    hasAdminRole: boolean = false;
    allowAllRegions: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;
    loadingCounter: number = 0;
    eligibilityCategoryTypes: any = {};

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    resunduplicatedStudentEligibilities: UnduplicatedStudentEligibilities;
    resDistrictStudentEligibilities: StudentEligibilityCounts;
    lstSearchCountResponse: UnduplicatedStudentEligibilities[];
    dataSourceStudentEligibilities = new MatTableDataSource<UnduplicatedStudentEligibilities>();
    dataSourceSchoolRegion = new MatTableDataSource<ChosenRegion>();
    dataSourceSchoolDistricts = new MatTableDataSource<ChosenSchoolDistrict>();
    isLoadingResults: boolean = false;
    subEligibilitySubscription: Subscription;
    strExportFileName = 'CountsReport';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;
    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;

    htmlToStringPipe: HtmlToStringPipe = new HtmlToStringPipe();

    msg: MsgModel;
    numberCommaPipe: NumberCommaPipe = new NumberCommaPipe();

    settings: any = {
        '/reports/instant-eligibility-counts': {
            TITLE: 'Counts Report',
            EXPORTFILENAME: 'CountsReport',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            QUESTION_HELP_TEXT_ID: 248,
            COLUMN_HEADERS: ['Region', 'MSIDNumber', 'SSID', 'Name', 'DOB', 'Gender', 'Category'],
            COLUMN_WIDTHS: [52, 52, 52, 82, 82, 52, 52],
            COLUMNS: ['REGION', 'MSIDNumber', 'SSID', 'NAME', 'DOB', 'Gender', 'Category']
        }
    };

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private studentEligibilitiesService: StudentEligibilitiesService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService,
        private utilityService: UtilityService,
        private apiFetchExportDataService: ApiFetchExportDataService,
        router: Router,
        private childReportsService: ChildReportsService,
        private regionDataService: RegionDataService,
        private loginTokenService: LoginTokenService
    ) {}

    ngOnInit(): void {
        this.initUser();
        this.indexEligibilityCategoryTypes();
    }

    initUser() {
        let user = this.loginTokenService.getUser();
        let adminUserIds = [1, 9]; // System Administrator (1), State Administrator (9)
        this.hasAdminRole = user.USER_ROLES?.some((ur) => adminUserIds.includes(ur.ROLE?.ID ? ur.ROLE.ID : 0))!;
        if (this.hasAdminRole || this.allowAllRegions) {
            console.log('allowed regionalexport');
            this.bAllowRegionalExport = true;
        } else {
            this.bAllowRegionalExport = false;
        }
    }

    indexEligibilityCategoryTypes() {
        this.studentEligibilitiesService.indexEligibilityCategoryTypes().subscribe((res) => {
            if (res.eligibilityCategoryTypes) {
                res.eligibilityCategoryTypes.forEach((category: any) => {
                    category.TOOLTIP = this.htmlToStringPipe.transform(category.TOOLTIP);
                    this.eligibilityCategoryTypes[category.TYPE] = category.TOOLTIP;
                });
            } else if (res?.msg) {
            } else {
            }
        });
    }

    ngAfterViewInit() {
        this.dataSourceSchoolRegion.sort = this.regionSort;
        this.dataSourceSchoolDistricts.sort = this.districtSort;
    }

    search() {
        //school district selected then search by school district else by school region
        if (this.selectedPerformancePeriod != this.performancePeriod) {
            this.selectedPerformancePeriod = this.performancePeriod;

            this.studentEligibilitiesService
                .GetUnduplicatedStudentEligibilities({ performancePeriod: this.selectedPerformancePeriod })
                .subscribe((x: UnduplicatedStudentEligibilities) => {
                    if (x) {
                        let a: UnduplicatedStudentEligibilities[] = [x];

                        this.dataSourceStudentEligibilities = new MatTableDataSource(a);
                    } else {
                        this.dataSourceStudentEligibilities = new MatTableDataSource([
                            {
                                EIP: 0,
                                EST: 0,
                                COS1: 0,
                                EC2: 0,
                                EC1: 0,
                                COS2: 0,
                                COS3: 0
                            }
                        ]);
                    }
                });
        }
        this.lstchosenSchoolRegion = [];
        this.lstchosenSchoolDistrict = [];
        this.dataSourceSchoolRegion = new MatTableDataSource<ChosenRegion>();
        this.dataSourceSchoolDistricts = new MatTableDataSource<ChosenSchoolDistrict>();

        if (this.lstSelecteddistricts?.length <= 0) this.invokeStudentEligibilityCountAPI(true);
        else this.invokeStudentEligibilityCountAPI(false);
    }

    //Get Data using Performance Year
    performancePeriodEvent(performanceYear: string) {
        if (this.performancePeriod != performanceYear) {
            this.performancePeriod = performanceYear;
        }
    }

    //Get Data using Region and  School District
    invokeStudentEligibilityCountAPI(isRegion: boolean) {
        this.isLoadingResults = true;
        this.loadingCounter = 0;
        if (isRegion) {
            this.lstchosenSchoolRegion = [];
            this.studentEligibilitiesService
                .GetUnduplicatedStudentEligibilityCount({ chosenRegions: this.lstSelectedRegion, performancePeriod: this.selectedPerformancePeriod })
                .subscribe((x: UnduplicatedStudentEligibilities) => {
                    this.resunduplicatedStudentEligibilities = x;
                });
            this.lstSelectedRegion.forEach((element) => {
                const inputParameter = {
                    chosenRegions: [element],
                    performancePeriod: this.selectedPerformancePeriod
                };
                this.studentEligibilitiesService.GetStudentEligibilityCountRegion(inputParameter).subscribe((x: StudentEligibilityCounts) => {
                    if (x.chosenRegion) {
                        this.lstchosenSchoolRegion.push(x.chosenRegion);
                        this.lstchosenSchoolRegion.sort((a, b) => parseInt(a.CODE) - parseInt(b.CODE));
                        this.dataSourceSchoolRegion.data = this.lstchosenSchoolRegion;
                        //this.dataSourceSchoolRegion.paginator = this.regionPaginator;
                        this.loadingCounter++;

                        if (this.loadingCounter === this.lstSelectedRegion.length) {
                            this.isLoadingResults = false;
                        }
                    }
                });
            });
        } else {
            this.lstchosenSchoolDistrict = [];
            this.studentEligibilitiesService
                .GetUnduplicatedStudentEligibilityCount({
                    chosenSchoolDistricts: this.lstSelecteddistricts,
                    performancePeriod: this.selectedPerformancePeriod
                })
                .subscribe((x: UnduplicatedStudentEligibilities) => {
                    this.resunduplicatedStudentEligibilities = x;
                    console.log('got unduplicatedstudenteligiblities:');
                    console.log(x);
                });
            this.lstSelecteddistricts.forEach((element) => {
                const inputParameter = {
                    chosenSchoolDistricts: [element],
                    performancePeriod: this.selectedPerformancePeriod
                };
                this.subEligibilitySubscription = this.studentEligibilitiesService
                    .GetStudentEligibilityCountRegion(inputParameter)
                    .subscribe((x: StudentEligibilityCounts) => {
                        if (x.chosenSchoolDistrict) {
                            this.resDistrictStudentEligibilities = x;
                            this.lstchosenSchoolDistrict.push(x.chosenSchoolDistrict);
                            this.lstchosenSchoolDistrict.sort((a, b) => a.DISTRICTS.localeCompare(b.DISTRICTS));
                            this.dataSourceSchoolDistricts.data = this.lstchosenSchoolDistrict;
                            //this.dataSourceSchoolDistricts.paginator = this.districtPaginator;
                            this.loadingCounter++;

                            if (this.loadingCounter === this.lstSelecteddistricts.length) {
                                this.isLoadingResults = false;
                            }
                        }
                    });
            });
        }
    }

    getTotal(elementName: string, isRegion: boolean) {
        let a = isRegion ? this.lstchosenSchoolRegion : this.lstchosenSchoolDistrict;
        if (elementName == 'EIP') return a.map((t) => t.EIP).reduce((acc, value) => acc + value, 0);
        else if (elementName == 'EC1') return a.map((t) => t.EC1).reduce((acc, value) => acc + value, 0);
        else if (elementName == 'EC2') return a.map((t) => t.EC2).reduce((acc, value) => acc + value, 0);
        else if (elementName == 'EST') return a.map((t) => t.EST).reduce((acc, value) => acc + value, 0);
        else return 0;
    }

    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        //Once ray emits reset for District need to implment.
        this.isLoadingResults = false;
        this.lstchosenSchoolRegion = [];
        this.lstchosenSchoolDistrict = [];
    }

    regionSortChange(sortState: Sort) {
        this.dataSourceSchoolRegion.sort = this.regionSort;
    }
    districtSortChange(sortState: Sort) {
        this.dataSourceSchoolDistricts.sort = this.districtSort;
    }

    // Dialog Modal
    openStudentRegionDialog(element: any, eligibilityCategoryType: string) {
        let payload = this.generatePayload();
        payload.chosenRegion = element;
        switch (eligibilityCategoryType) {
            case 'EIP':
                payload.eligibilityCategoryType = { ID: 1, TYPE: 'EIP' };
                break;
            case 'EC1':
                payload.eligibilityCategoryType = { ID: 2, TYPE: 'CAT I' };
                break;
            case 'EC2':
                payload.eligibilityCategoryType = { ID: 3, TYPE: 'CAT II' };
                break;
            case 'EST':
                payload.eligibilityCategoryType = { ID: 4, TYPE: 'Eligible Today' };
                break;
            default:
                break;
        }
        payload.performancePeriod = this.selectedPerformancePeriod;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = payload;
        dialogConfig.minWidth = '80vh';
        dialogConfig.maxHeight = '90vh';
        const dialogRef = this.dialog.open(CountsChildrenModalComponent, dialogConfig);
    }

    openStudentSchoolDistrictDialog(element: any, eligibilityCategoryType: string) {
        let payload = this.generatePayload();
        payload.chosenSchoolDistrict = element;
        switch (eligibilityCategoryType) {
            case 'EIP':
                payload.eligibilityCategoryType = { ID: 1, TYPE: 'EIP' };
                break;
            case 'EC1':
                payload.eligibilityCategoryType = { ID: 2, TYPE: 'CAT I' };
                break;
            case 'EC2':
                payload.eligibilityCategoryType = { ID: 3, TYPE: 'CAT II' };
                break;
            case 'EST':
                payload.eligibilityCategoryType = { ID: 4, TYPE: 'Eligible Today' };
                break;
            default:
                break;
        }
        payload.performancePeriod = this.selectedPerformancePeriod;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = payload;
        dialogConfig.minWidth = '80vh';
        dialogConfig.maxHeight = '90vh';
        const dialogRef = this.dialog.open(CountsChildrenModalComponent, dialogConfig);
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.lstSelectedRegion;

        payload.columns = [];
        return payload;
    }

    downloadExcel() {
        let payload = this.generateExportPayload();

        if (payload.data.duplicated.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            if (this.lstchosenSchoolDistrict.length <= 0) {
                this.apiMsinExportsService.exportCountsRegionReport(payload).subscribe({
                    next: (res2: any) => {
                        const blob = new Blob([res2], { type: 'application/xlsx' });

                        let fileName = this.utilityService.fnMakeFileNameTime(('CountsReport_Regions' + '_' + this.performancePeriod).replace(/\s+/g, '_'));

                        const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                        const url = URL.createObjectURL(renamedFile);

                        const a = document.createElement('a');
                        a.href = url;
                        fileName = fileName.trimLeft();

                        a.download = fileName + '.xlsx';
                        a.click();
                        if (a && a.parentNode === document.body) {
                            document.body.removeChild(a);
                        }

                        URL.revokeObjectURL(url);
                    },
                    error: (e) => {
                        this.msg = { SUCCESS: false, MSG: 'Error exporting Counts Report.' };
                        this.isExporting = false;
                    },
                    complete: () => {
                        this.isExporting = false;
                    }
                });
            } else {
                this.apiMsinExportsService.exportCountsSchoolDistrictReport(payload).subscribe({
                    next: (res2: any) => {
                        const blob = new Blob([res2], { type: 'application/xlsx' });

                        let fileName = this.utilityService.fnMakeFileNameTime(
                            ('CountsReport_SchoolDistricts' + '_' + this.performancePeriod).replace(/\s+/g, '_')
                        );

                        const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                        const url = URL.createObjectURL(renamedFile);

                        const a = document.createElement('a');
                        a.href = url;
                        fileName = fileName.trimLeft();

                        a.download = fileName + '.xlsx';
                        a.click();
                        if (a && a.parentNode === document.body) {
                            document.body.removeChild(a);
                        }

                        URL.revokeObjectURL(url);
                    },
                    error: (e) => {
                        this.msg = { SUCCESS: false, MSG: 'Error exporting Counts Report.' };
                        this.isExporting = false;
                    },
                    complete: () => {
                        this.isExporting = false;
                    }
                });
            }
        }
    }

    downloadExcelStudents() {
        this.isExporting = true;
        this.msg = new MsgModel();

        let exportParm: any = {};
        exportParm.chosenRegions = this.lstSelectedRegion;
        exportParm.performancePeriod = this.performancePeriod;

        let payload: any = {};

        this.apiFetchExportDataService.getChildReportsCountDetails(exportParm).subscribe({
            next: (res: any) => {
                if (res.students) {
                    payload = {
                        settings: this.performancePeriod,
                        data: JSON.parse(res.students)
                    };
                }
            },
            error: (e) => {
                this.msg = { SUCCESS: false, MSG: 'Error retrieving Counts Report Students.' };
                this.isExporting = false;
            },
            complete: () => {
                this.apiMsinExportsService.exportCountsStudentsReport(payload).subscribe({
                    next: (res2: any) => {
                        const blob = new Blob([res2], { type: 'application/xlsx' });

                        let fileName = this.utilityService.fnMakeFileNameTime(
                            ('CountsReport_CatIandCatII_Students' + '_' + this.performancePeriod).replace(/\s+/g, '_')
                        );

                        const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                        const url = URL.createObjectURL(renamedFile);

                        const a = document.createElement('a');
                        a.href = url;
                        fileName = fileName.trimLeft();

                        a.download = fileName + '.xlsx';
                        a.click();
                        if (a && a.parentNode === document.body) {
                            document.body.removeChild(a);
                        }

                        URL.revokeObjectURL(url);
                    },
                    error: (e) => {
                        this.msg = { SUCCESS: false, MSG: 'Error exporting Counts Report.' };
                        this.isExporting = false;
                    },
                    complete: () => {
                        this.isExporting = false;
                    }
                });
            }
        });
    }

    generateExportPayload() {
        let payload = {
            settings: {
                schoolYear: this.performancePeriod
            },
            data: {
                unduplicated: [this.generateAllUnduplicatedTotal()],
                duplicated: []
            }
        };

        let duplicated;

        if (this.lstSelecteddistricts.length <= 0) {
            duplicated = JSON.parse(
                JSON.stringify(
                    this.dataSourceSchoolRegion.data.map((region) => ({
                        NAME: region.CODE,
                        EIP: region.EIP,
                        EC1: region.EC1,
                        EC2: region.EC2,
                        EST: region.EST
                    }))
                )
            );
            duplicated.push(this.generateTotal(true));
            duplicated.push(this.generateUnduplicatedTotal());

            payload.data.duplicated = duplicated;
        } else {
            duplicated = JSON.parse(
                JSON.stringify(
                    this.dataSourceSchoolDistricts.data.map((sd) => ({
                        NAME: sd.DISTRICTS,
                        EIP: sd.EIP,
                        EC1: sd.EC1,
                        EC2: sd.EC2,
                        EST: sd.EST
                    }))
                )
            );
            duplicated.push(this.generateTotal(false));
            duplicated.push(this.generateUnduplicatedTotal());

            payload.data.duplicated = duplicated;
        }

        return payload;
    }

    generateAllUnduplicatedTotal() {
        let totalRow = {
            NAME: 'Unduplicated Total',
            EIP: 0,
            EC1: 0,
            EC2: 0,
            EST: 0
        };

        let unduplicatedTotal = JSON.parse(JSON.stringify(this.dataSourceStudentEligibilities.data ? this.dataSourceStudentEligibilities.data[0] : {}));

        totalRow.EIP = unduplicatedTotal.EIP;
        totalRow.EC1 = unduplicatedTotal.EC1;
        totalRow.EC2 = unduplicatedTotal.EC2;
        totalRow.EST = unduplicatedTotal.EST;

        return totalRow;
    }

    generateTotal(isRegion: boolean) {
        let totalRow = {
            NAME: 'Total',
            EIP: 0,
            EC1: 0,
            EC2: 0,
            EST: 0
        };

        if (isRegion) {
            totalRow.EIP = this.getTotal('EIP', true);
            totalRow.EC1 = this.getTotal('EC1', true);
            totalRow.EC2 = this.getTotal('EC2', true);
            totalRow.EST = this.getTotal('EST', true);
        } else {
            totalRow.EIP = this.getTotal('EIP', false);
            totalRow.EC1 = this.getTotal('EC1', false);
            totalRow.EC2 = this.getTotal('EC2', false);
            totalRow.EST = this.getTotal('EST', false);
        }

        return totalRow;
    }

    generateUnduplicatedTotal() {
        let totalRow = {
            NAME: 'Unduplicated Total',
            EIP: 0,
            EC1: 0,
            EC2: 0,
            EST: 0
        };

        totalRow.EIP = this.resunduplicatedStudentEligibilities.EIP ? this.resunduplicatedStudentEligibilities.EIP : 0;
        totalRow.EC1 = this.resunduplicatedStudentEligibilities.EC1 ? this.resunduplicatedStudentEligibilities.EC1 : 0;
        totalRow.EC2 = this.resunduplicatedStudentEligibilities.EC2 ? this.resunduplicatedStudentEligibilities.EC2 : 0;
        totalRow.EST = this.resunduplicatedStudentEligibilities.EST ? this.resunduplicatedStudentEligibilities.EST : 0;

        return totalRow;
    }
}
